import { OrderClass, AssetType, SizeRatio, StrategyType, OrderActionDirection, OptionType, StrikeRules, ExpirationRules, DirectionRules, } from '@tradingblock/types';
import { isIndexSymbol } from '..';
export { validateOrder } from './validation';
export { SchemaValidator } from './strategyValidator';
export const Shares = {
    info: {
        Name: 'Shares',
        Symbol: 'S',
        LegsAmount: 1,
        Strikes: 0,
        PermissionLevel: 0,
        SizeRatio: SizeRatio.NA,
        SvgPath: 'shares',
        IconKind: 'svg',
    },
    profile: {
        Rules: {
            SpreadRatio: SizeRatio.NA,
        },
        OrderClass: OrderClass.Single,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Equity,
                Direction: OrderActionDirection.Long,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 9,
            StrategyType: StrategyType.Bull,
        },
        [OrderActionDirection.Short]: {
            Strength: 8,
            StrategyType: StrategyType.Bear,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // if isLimitOrder
                // then 	if MktAsk(S) > 0   // if there is available market offer in S greater than 0
                //   then X = Min( MktAsk(S), Px(S))  // Px(S) is the client’s specified price for the strategy
                //   else X = Px(S)
                // else 	if MktAsk(S) > 0
                // 	then X = MktAsk(S)  // Market best offer will be a good estimate for execution price
                // 	else X = Last(S)  // Last price will be a good estimate for execution price X
                // fi
                // margin = ( X < 5 ? X : 0.5 * X ) * quantity;
                const ask = quotes[0].AskPrice;
                const last = quotes[0].LastTradePrice;
                let x;
                if (isLimitOrder) {
                    if (ask > 0) {
                        x = Math.min(ask, offerPrice);
                    }
                    else {
                        x = offerPrice;
                    }
                }
                else {
                    if (ask > 0) {
                        x = ask;
                    }
                    else {
                        x = last;
                    }
                }
                return x < 5 ? x : 0.5 * x;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // margin value is based on estimated execution price X of selling shares
                // if isLimitOrder
                // 	then	X = Max( MktBid(S), Px(S))) // Px(S) is the client’s specified price for the strategy
                // 	else	X = Max( MktBid(S), Last(S)) // conservative estimate of the execution price X
                // fi
                // margin = ( X < 2.5 ? 2.5 : ( X < 5 ? X : (X < 50 /3.0 ? 5 : 0.3 * X ) ) ) * quantity
                const bid = quotes[0].BidPrice;
                const last = quotes[0].LastTradePrice;
                let x;
                if (isLimitOrder) {
                    x = Math.max(bid, offerPrice);
                }
                else {
                    x = Math.max(bid, last);
                }
                return x < 2.5 ? 2.5 : x < 5 ? x : x < 50 / 3 ? 5 : 0.3 * x;
            },
        },
    },
};
export const Call = {
    // validation: {
    //   orderSchema: orderSchemaBuilder(OrderClass.Single, [
    //     {
    //       assetType: AssetType.Option,
    //       action: [OrderAction.Buy, OrderAction.Sell],
    //       spreadRatio: 1,
    //     },
    //   ]),
    // },
    info: {
        Name: 'Call',
        Symbol: 'C',
        LegsAmount: 1,
        Strikes: 1,
        PermissionLevel: 1,
        SizeRatio: SizeRatio.NA,
        SvgPath: 'call',
        IconKind: 'svg',
    },
    profile: {
        Rules: {
            SpreadRatio: SizeRatio.NA,
        },
        Bidirectional: true,
        OrderClass: OrderClass.Single,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Long,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 10,
            StrategyType: StrategyType.Bull,
        },
        [OrderActionDirection.Short]: {
            Strength: 9,
            StrategyType: StrategyType.Bear,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: () => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // X = Last(S)
                // if S is Index
                // then	margin = Max( 0.1 * X, 0.15 * (X – Max( 0, K – X ) ) ) * quantity * Multiplier
                // else	// Missing MktAsk shall be treated as zero
                // 	if MktAsk > 0 then X = Max( Last(S), MktAsk(S) )  // MktAsk(S) cannot be infinity either
                //    margin = Max( 0.1 * X, 0.20 * (X – Max( 0, K – X ) ) ) * quantity * Multiplier
                // fi
                const symbol = quotes[0].Symbol;
                const ask = quotes[0].AskPrice;
                if (Object.values(legs).length <= 0) {
                    return 0;
                }
                const strike = Object.values(legs)[0].Strike;
                let x = quotes[0].LastTradePrice;
                if (isIndexSymbol(symbol)) {
                    return Math.max(0.1 * x, 0.15 * (x - Math.max(0, strike - x)));
                }
                else {
                    if (ask > 0) {
                        x = Math.max(x, ask);
                    }
                    return Math.max(0.1 * x, 0.2 * (x - Math.max(0, strike - x)));
                }
            },
        },
    },
};
export const Put = {
    // validation: {
    //   orderSchema: orderSchemaBuilder(OrderClass.Single, [
    //     {
    //       assetType: AssetType.Option,
    //       action: [OrderAction.Buy, OrderAction.Sell],
    //       spreadRatio: 1,
    //     },
    //   ]),
    // },
    info: {
        Name: 'Put',
        Symbol: 'P',
        LegsAmount: 1,
        Strikes: 1,
        PermissionLevel: 1,
        SizeRatio: SizeRatio.NA,
        SvgPath: 'put',
        IconKind: 'svg',
    },
    profile: {
        Rules: {
            SpreadRatio: SizeRatio.NA,
        },
        Bidirectional: true,
        OrderClass: OrderClass.Single,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 10,
            StrategyType: StrategyType.Bear,
        },
        [OrderActionDirection.Short]: {
            Strength: 8,
            StrategyType: StrategyType.Bull,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: () => {
                // 0
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // margin is based on estimate of current value X of the underlying symbol S
                // X = Last(S)
                // if S is Index
                //   then margin = Max( 0.1 * K, 0.15 * (X – Max( 0, X - K ) ) )
                //   else margin = Max( 0.1 * K, 0.20 * (X – Max( 0, X - K ) ) )
                // fi
                //TODO: Ask Milan about how the user set price plays a role in the the margin calculation
                const symbol = quotes[0].Symbol;
                if (Object.values(legs).length <= 0) {
                    return 0;
                }
                const strike = Object.values(legs)[0].Strike;
                let x = quotes[0].LastTradePrice;
                if (isIndexSymbol(symbol)) {
                    return Math.max(0.1 * strike, 0.15 * (x - Math.max(0, x - strike)));
                }
                else {
                    return Math.max(0.1 * strike, 0.2 * (x - Math.max(0, x - strike)));
                }
            },
        },
    },
};
export const CoveredCall = {
    info: {
        Name: 'Covered Call',
        Symbol: 'CC',
        LegsAmount: 2,
        Strikes: 1,
        PermissionLevel: 1,
        SizeRatio: SizeRatio.HundredToOne,
        SvgPath: 'covered-call',
        IconKind: 'svg',
    },
    profile: {
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 100,
                AssetType: AssetType.Equity,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Short,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 6,
            StrategyType: StrategyType.Bull,
        },
        [OrderActionDirection.Short]: {
            Strength: 7,
            StrategyType: StrategyType.Bear,
        },
        Rules: {
            SpreadRatio: SizeRatio.HundredToOne,
            Direction: DirectionRules.DifferentDirections,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // // buying stock and selling call
                // // margin value is based on estimated price X of shares
                // // Px(S) is the client’s specified price for the strategy
                // if isLimitOrder
                //  then
                //    if MktAsk(S) > 0   // if there is available market offer in S greater than 0
                //    then X = Min( MktAsk(S), Px(S) + Max(0, MktAsk(S) - K)
                //    // Px(S) is the client’s specified price for the strategy
                //    else X = Min( Last(S), Px(S) + Max(0, Last(S) - K)
                // else
                //  if MktAsk(S) > 0
                // 	  then X = MktAsk(S)  // Market best offer will be a good estimate for execution price
                // 	  else X = Last(S)  // Last price will be a good estimate for execution price X
                // fi
                // margin = ( X < 5 ? X : 0.5 * X ) * quantity * Multiplier;
                // TODO: ask what should be the default value of X, inferred last price
                const ask = quotes[0].AskPrice;
                if (Object.values(legs).length <= 1) {
                    return 0;
                }
                const strike = Object.values(legs)[1].Strike;
                let x;
                if (isLimitOrder) {
                    if (ask > 0) {
                        x = Math.min(ask, offerPrice + Math.max(0, ask - strike));
                    }
                    else {
                        x = Math.min(quotes[0].LastTradePrice, offerPrice + Math.max(0, quotes[0].LastTradePrice - strike));
                    }
                }
                else {
                    if (ask > 0) {
                        x = ask;
                    }
                    else {
                        x = quotes[0].LastTradePrice;
                    }
                }
                return x < 5 ? x : 0.5 * x;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // // selling stock and buying call
                // // margin value is based on estimated price X of shares
                // if MktAsk(S) > 0
                // then 	X = MktAsk(S)
                // else 	X = Last(S)
                // fi
                // margin = MAX( 0.5 * X, Min(0.1 * K + Max(0, K-X), X < 2.5 ? 2.5 : ( X < 5 ? X : (X < 50 /3.0 ? 5 : 0.3 * X ) ) ) * quantity * Multiplier
                const symbol = quotes[0].Symbol;
                const ask = quotes[0].AskPrice;
                const bid = quotes[0].BidPrice;
                if (Object.values(legs).length <= 1) {
                    return 0;
                }
                const strike = Object.values(legs)[1].Strike;
                const qty = 1;
                let x = null;
                if (ask > 0) {
                    x = ask;
                }
                else {
                    x = quotes[0].LastTradePrice;
                }
                return Math.max(0.5 * x, Math.min(0.1 * strike + Math.max(0, strike - x), x < 2.5 ? 2.5 : x < 5 ? x : x < 50 / 3.0 ? 5 : 0.3 * x));
            },
        },
    },
};
export const MarriedPut = {
    info: {
        Name: 'Married Put',
        Symbol: 'MP',
        LegsAmount: 2,
        Strikes: 1,
        PermissionLevel: 1,
        SizeRatio: SizeRatio.HundredToOne,
        SvgPath: 'married-put',
        IconKind: 'svg',
    },
    profile: {
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 100,
                AssetType: AssetType.Equity,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 7,
            StrategyType: StrategyType.Bull,
        },
        [OrderActionDirection.Short]: {
            Strength: 6,
            StrategyType: StrategyType.Bear,
        },
        Rules: {
            SpreadRatio: SizeRatio.HundredToOne,
            Direction: DirectionRules.SameDirections,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // // buying stock and buying put
                // // margin value is based on estimated price X of shares
                // if isLimitOrder
                // then 	if MktAsk(S) > 0   // if there is available market offer in S greater than 0
                // then X = Min( MktAsk(S), Px(S))  // Px(S) is the client’s specified price for the strategy
                // else X = Min( Last(S), Px(S) )
                // else 	if MktAsk(S) > 0
                // 	then X = MktAsk(S)  // Market best offer will be a good estimate for execution price
                // 	else X = Last(S)  // Last price will be a good estimate for execution price X
                // 	fi
                // fi
                // margin = ( X < 5 ? X : 0.5 * X ) * quantity * Multiplier;
                const ask = quotes[0].AskPrice;
                const last = quotes[0].LastTradePrice;
                let x;
                if (isLimitOrder) {
                    if (ask > 0) {
                        x = Math.min(ask, offerPrice);
                    }
                    else {
                        x = Math.min(last, offerPrice);
                    }
                }
                else {
                    if (ask > 0) {
                        x = ask;
                    }
                    else {
                        x = last;
                    }
                }
                return x < 5 ? x : 0.5 * x;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // // selling stock and selling put
                // // margin value is based on estimated price X of shares
                // if MktAsk(S) > 0
                // then 	X = MktAsk(S)
                // else 	X = Last(S)
                // fi
                // margin = MAX( 0.5 * X + MAX( 0, K – X ), X < 2.5 ? 2.5 : ( X < 5 ? X : (X < 50 /3.0 ? 5 : 0.3 * X ) ) ) * quantity * Multiplier
                const ask = quotes[0].AskPrice;
                const strike = Object.values(legs)[0].Strike;
                let x;
                if (ask > 0) {
                    x = ask;
                }
                else {
                    x = quotes[0].LastTradePrice;
                }
                return Math.max(0.5 * x + Math.max(0, strike - x), x < 2.5 ? 2.5 : x < 5 ? x : x < 50 / 3.0 ? 5 : 0.3 * x);
            },
        },
    },
};
export const CallCalendar = {
    info: {
        Name: 'Call Calendar',
        Symbol: 'CT',
        LegsAmount: 2,
        Strikes: 2,
        PermissionLevel: 1,
        SizeRatio: SizeRatio.OneToOne,
        BidirectionalDebitCredit: true,
        Icon: 'fal fa-calendar-alt',
        IconKind: 'icon',
    },
    profile: {
        Rules: {
            Expiration: ExpirationRules.DifferentExpiries,
            SpreadRatio: SizeRatio.OneToOne,
            Direction: DirectionRules.DifferentDirections,
            Strike: StrikeRules.Any,
        },
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 4,
            StrategyType: StrategyType.Bull,
        },
        [OrderActionDirection.Short]: {
            Strength: 4,
            StrategyType: StrategyType.Bear,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // // buying later expiring call with strike K1 and selling earlier expiring call with strike K2
                // if IRA Aaccount
                // 	then 	// margin is the maximum of zero and strike difference
                // 	margin = Max( 0, K2 – K1 ) * quantity * Multiplier
                // else
                // 	X = Last(S)
                // 	if S is Index then
                // 		margin = Min( Max( 0, K2 – K1 ), Max( 0.1 * X, 0.15 * (X – Max( 0, K2 – X ) ) ) ) * quantity * Multiplier
                // 	else	// Missing MktAsk shall be treated as zero
                // 		if MktAsk > 0 then
                // 			X = Max( Last(S), MktAsk(S) )
                // 		fi
                // 		margin = Min( Max( 0, K2 – K1 ), Max( 0.1 * X, 0.20 * (X – Max( 0, K2 – X ) ) ) ) * quantity * Multiplier
                // 	fi
                // fi
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                if (isIRA) {
                    return Math.max(0, K2 - K1);
                }
                let x = quotes[0].LastTradePrice;
                let symbol = quotes[0].Symbol;
                let ask = quotes[0].AskPrice;
                if (isIndexSymbol(symbol)) {
                    return Math.min(Math.max(0, K2 - K1), Math.max(0.1 * x, 0.15 * (x - Math.max(0, K2 - x))));
                }
                else {
                    if (ask > 0) {
                        x = Math.max(x, ask);
                    }
                    return Math.min(Math.max(0, K2 - K1), Math.max(0.1 * x, 0.2 * (x - Math.max(0, K2 - x))));
                }
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // // selling later expiring call with strike K1 and buying earlier expiring call with strike K2
                // // margin is the margin of the short call with strike K1 based on estimate of current value X of the
                // // underlying symbol S
                // X = Last(S)
                // if S is Index then
                // 	margin = Max( 0.1 * X, 0.15 * (X – Max( 0, K1 – X ) ) ) * quantity * Multiplier
                // else	// Missing MktAsk shall be treated as zero
                // 	if MktAsk > 0 then
                // 		X = Max( Last(S), MktAsk(S) )
                // 	fi
                // 	margin = Max( 0.1 * X, 0.20 * (X – Max( 0, K1 – X ) ) ) * quantity * Multiplier
                // fi
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                let x = quotes[0].LastTradePrice;
                let symbol = quotes[0].Symbol;
                if (isIndexSymbol(symbol)) {
                    return Math.max(0.1 * x, 0.15 * (x - Math.max(0, K1 - x)));
                }
                else {
                    let ask = quotes[0].AskPrice;
                    if (ask > 0) {
                        x = Math.max(x, ask);
                    }
                    return Math.max(0.1 * x, 0.2 * (x - Math.max(0, K1 - x)));
                }
            },
        },
    },
};
export const PutCalendar = {
    info: {
        Name: 'Put Calendar',
        Symbol: 'PT',
        LegsAmount: 2,
        Strikes: 2,
        PermissionLevel: 1,
        SizeRatio: SizeRatio.OneToOne,
        BidirectionalDebitCredit: true,
        Icon: 'fal fa-calendar-alt',
        IconKind: 'icon',
    },
    profile: {
        Rules: {
            Expiration: ExpirationRules.DifferentExpiries,
            SpreadRatio: SizeRatio.OneToOne,
            Direction: DirectionRules.DifferentDirections,
            Strike: StrikeRules.Any,
        },
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 4,
            StrategyType: StrategyType.Bear,
        },
        [OrderActionDirection.Short]: {
            Strength: 4,
            StrategyType: StrategyType.Bull,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // // buying later expiring put with strike K1 and selling earlier expiring put with strike K2
                // if IRA Aaccount then 	// margin is the maximum of zero and strike difference
                // 	margin = Max( 0, K1 – K2 ) * quantity * Multiplier
                // else
                // 	X = Last(S)
                // 	if S is Index then
                // 		margin = Min( Max( 0, K1 – K2 ), Max( 0.1 * K2, 0.15 * (X – Max( 0, X – K2 ) ) ) ) * quantity * Multiplier
                // 	else
                // 		margin = Min( Max( 0, K1 – K2 ), Max( 0.1 * K2, 0.20 * (X – Max( 0, X – K2 ) ) ) ) * quantity * Multiplier
                // 	fi
                // fi
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                if (isIRA) {
                    return Math.max(0, K1 - K2);
                }
                else {
                    let x = quotes[0].LastTradePrice;
                    let symbol = quotes[0].Symbol;
                    if (isIndexSymbol(symbol)) {
                        return Math.min(Math.max(0, K1 - K2), Math.max(0.1 * K2, 0.15 * (x - Math.max(0, x - K2))));
                    }
                    else {
                        return Math.min(Math.max(0, K1 - K2), Math.max(0.1 * K2, 0.2 * (x - Math.max(0, x - K2))));
                    }
                }
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // // selling later expiring put with strike K1 and buying earlier expiring put with strike K2
                // // margin is the margin of the short put with strike K1 based on estimate of current value X of the
                // // underlying symbol S
                // X = Last(S)
                // if S is Index then
                // 	margin = Max( 0.1 * K1, 0.15 * (X – Max( 0, X – K1 ) ) ) * quantity * Multiplier
                // else
                // 	margin = Max( 0.1 * K1, 0.20 * (X – Max( 0, X – K1 ) ) ) * quantity * Multiplier
                // fi
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const x = quotes[0].LastTradePrice;
                const symbol = quotes[0].Symbol;
                if (isIndexSymbol(symbol)) {
                    return Math.max(0.1 * K1, 0.15 * (x - Math.max(0, x - K1)));
                }
                else {
                    return Math.max(0.1 * K1, 0.2 * (x - Math.max(0, x - K1)));
                }
            },
        },
    },
};
export const CallVertical = {
    info: {
        Name: 'Call Vertical',
        Symbol: 'CV',
        LegsAmount: 2,
        Strikes: 2,
        PermissionLevel: 1,
        SizeRatio: SizeRatio.OneToOne,
        SvgPath: 'call-vertical',
        IconKind: 'svg',
    },
    profile: {
        Rules: {
            Expiration: ExpirationRules.SameExpiry,
            Strike: StrikeRules.IncreasingOrder,
            SpreadRatio: SizeRatio.OneToOne,
            Direction: DirectionRules.DifferentDirections,
        },
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Short,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 8,
            StrategyType: StrategyType.Bull,
        },
        [OrderActionDirection.Short]: {
            Strength: 6,
            StrategyType: StrategyType.Bear,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // selling call with lower strike K1 and buying call with higher strike K2, same expiration
                // if IRA Aaccount then 	// margin is the maximum risk
                // 	margin = | K2 – K1 | * quantity * Multiplier
                // else  	// margin will be the margin of the short call with the strike K1
                // 	X = Last(S)
                // 	if S is Index then
                // 		margin = Max( 0.1 * X, 0.15 * (X – Max( 0, K1 – X ) ) ) * quantity * Multiplier
                // 	else	// Missing MktAsk shall be treated as zero
                // 		if MktAsk > 0 then
                // 			X = Max( Last(S), MktAsk(S) )
                // 		fi
                // 		margin = Max( 0.1 * X, 0.20 * (X – Max( 0, K1 – X ) ) ) * quantity * Multiplier
                // 	fi
                // fi
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                const strikeDiff = Math.abs(K2 - K1);
                if (isIRA) {
                    return strikeDiff;
                }
                let x = quotes[0].LastTradePrice;
                const symbol = quotes[0].Symbol;
                const ask = quotes[0].AskPrice;
                if (isIndexSymbol(symbol)) {
                    const margin = Math.max(0.1 * x, 0.15 * (x - Math.max(0, K1 - x)));
                    return Math.min(strikeDiff, margin);
                }
                else {
                    if (ask > 0) {
                        x = Math.max(x, ask);
                    }
                    const margin = Math.max(0.1 * x, 0.2 * (x - Math.max(0, K1 - x)));
                    return Math.min(strikeDiff, margin);
                }
            },
        },
    },
};
export const PutVertical = {
    info: {
        Name: 'Put Vertical',
        Symbol: 'PV',
        LegsAmount: 2,
        Strikes: 2,
        PermissionLevel: 1,
        SizeRatio: SizeRatio.OneToOne,
        SvgPath: 'put-vertical',
        IconKind: 'svg',
    },
    profile: {
        Rules: {
            Expiration: ExpirationRules.SameExpiry,
            Strike: StrikeRules.DecreasingOrder,
            SpreadRatio: SizeRatio.OneToOne,
            Direction: DirectionRules.DifferentDirections,
        },
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Short,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 8,
            StrategyType: StrategyType.Bear,
        },
        [OrderActionDirection.Short]: {
            Strength: 6,
            StrategyType: StrategyType.Bull,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // selling put with higher strike K1 and buying put with lower strike K2, same expiration
                // if IRA Aaccount then 	// margin is the maximum risk
                // 	margin = | K1 – K2 | * quantity * Multiplier
                // else  	// margin will be the margin of the short put with the strike K1
                // 	X = Last(S)
                // 	if S is Index then
                // 		margin = Max( 0.1 * K, 0.15 * (X – Max( 0, X - K1 ) ) ) * quantity * Multiplier
                // 	else
                // 		margin = Max( 0.1 * K, 0.20 * (X – Max( 0, X – K1 ) ) ) * quantity * Multiplier
                // 	fi
                // fi
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                const strikeDiff = Math.abs(K1 - K2);
                if (isIRA) {
                    return strikeDiff;
                }
                let x = quotes[0].LastTradePrice;
                const symbol = quotes[0].Symbol;
                if (isIndexSymbol(symbol)) {
                    const margin = Math.max(0.1 * x, 0.15 * (x - Math.max(0, x - K1)));
                    return Math.min(strikeDiff, margin);
                }
                else {
                    const margin = Math.max(0.1 * x, 0.2 * (x - Math.max(0, x - K1)));
                    return Math.min(strikeDiff, margin);
                }
            },
        },
    },
};
export const CallButterfly = {
    info: {
        Name: 'Call Butterfly',
        Symbol: 'CF',
        LegsAmount: 3,
        Strikes: 3,
        PermissionLevel: 4,
        SizeRatio: SizeRatio.OneTwoOne,
        SvgPath: 'call-butterfly',
        IconKind: 'svg',
    },
    profile: {
        Rules: {
            Expiration: ExpirationRules.SameExpiry,
            Strike: StrikeRules.EquidistantStrikes,
            SpreadRatio: SizeRatio.OneTwoOne,
            Direction: DirectionRules.Butterfly,
        },
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 2,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Short,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Long,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 4,
            StrategyType: StrategyType.Bull,
        },
        [OrderActionDirection.Short]: {
            Strength: 3,
            StrategyType: StrategyType.Bear,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                //|K2 - K1|
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                return Math.abs(K2 - K1);
            },
        },
    },
};
export const PutButterfly = {
    info: {
        Name: 'Put Butterfly',
        Symbol: 'PF',
        LegsAmount: 3,
        Strikes: 3,
        PermissionLevel: 2,
        SizeRatio: SizeRatio.OneTwoOne,
        SvgPath: 'put-butterfly',
        IconKind: 'svg',
    },
    profile: {
        Rules: {
            Expiration: ExpirationRules.SameExpiry,
            Strike: StrikeRules.EquidistantStrikes,
            SpreadRatio: SizeRatio.OneTwoOne,
            Direction: DirectionRules.Butterfly,
        },
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 2,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Short,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 4,
            StrategyType: StrategyType.Bear,
        },
        [OrderActionDirection.Short]: {
            Strength: 3,
            StrategyType: StrategyType.Bull,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                //|K1 - K2|
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                return Math.abs(K1 - K2);
            },
        },
    },
};
export const Straddle = {
    info: {
        Name: 'Straddle',
        Symbol: 'SD',
        LegsAmount: 2,
        Strikes: 1,
        PermissionLevel: 4,
        SizeRatio: SizeRatio.OneToOne,
        SvgPath: 'straddle',
        IconKind: 'svg',
    },
    profile: {
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 7,
            StrategyType: StrategyType.Volatility,
        },
        [OrderActionDirection.Short]: {
            Strength: 0,
            StrategyType: StrategyType.Volatility,
        },
        Rules: {
            Expiration: ExpirationRules.SameExpiry,
            Strike: StrikeRules.SameStrikes,
            SpreadRatio: SizeRatio.OneToOne,
            Direction: DirectionRules.SameDirections,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // // selling a call and a put with the same strike
                // X = Last(S)
                // if S is Index then
                // 	margin = Max( Max( 0.1*X, 0.15*(X–Max(0,K–X))) , Max(0.1*K, 0.15*(X–Max(0,X-K)))) * quantity * Multiplier
                // else	// Missing MktAsk shall be treated as zero
                // 	if MktAsk > 0 then
                // 		X = Max( Last(S), MktAsk(S) )  // MktAsk(S) cannot be infinity either
                // 	margin = Max( Max( 0.1*X, 0.20*(X–Max(0,K–X))), Max(0.1*K, 0.20*(X–Max(0,X-K)))) * quantity * Multiplier
                // fi
                const legsArray = Object.values(legs);
                if (legsArray.length <= 0) {
                    return 0;
                }
                const K = legsArray[0].Strike;
                let x = quotes[0].LastTradePrice;
                const symbol = quotes[0].Symbol;
                if (isIndexSymbol(symbol)) {
                    return Math.max(Math.max(0.1 * x, 0.15 * Math.max(0, K - x)), Math.max(0.1 * K, 0.15 * Math.max(0, x - K)));
                }
                else {
                    const ask = quotes[0].AskPrice;
                    if (ask > 0) {
                        x = Math.max(x, ask);
                    }
                    return Math.max(Math.max(0.1 * x, 0.2 * Math.max(0, K - x)), Math.max(0.1 * K, 0.2 * Math.max(0, x - K)));
                }
            },
        },
    },
};
export const Strangle = {
    info: {
        Name: 'Strangle',
        Symbol: 'SG',
        LegsAmount: 2,
        Strikes: 2,
        PermissionLevel: 4,
        SizeRatio: SizeRatio.OneToOne,
        SvgPath: 'strangle',
        IconKind: 'svg',
    },
    profile: {
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 7,
            StrategyType: StrategyType.Volatility,
        },
        [OrderActionDirection.Short]: {
            Strength: 1,
            StrategyType: StrategyType.Volatility,
        },
        Rules: {
            Expiration: ExpirationRules.SameExpiry,
            Strike: StrikeRules.CallHigherThanPut,
            SpreadRatio: SizeRatio.OneToOne,
            Direction: DirectionRules.SameDirections,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // // selling a call and a put with different strikes, K1 Call strike, K2 Put Strike
                // X = Last(S)
                // if S is Index then
                // 	margin = Max( Max( 0.1*X, 0.15*(X–Max(0,K1–X))) , Max(0.1*K2, 0.15*(X–Max(0,X-K2)))) * quantity * Multiplier
                // else	// Missing MktAsk shall be treated as zero
                // 	if MktAsk > 0 then
                // 		X = Max( Last(S), MktAsk(S) )  // MktAsk(S) cannot be infinity either
                // 	margin = Max( Max( 0.1*X, 0.20*(X–Max(0,K1–X))), Max(0.1*K2, 0.20*(X–Max(0,X-K2)))) * quantity * Multiplier
                // fi
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                let x = quotes[0].LastTradePrice;
                const symbol = quotes[0].Symbol;
                if (isIndexSymbol(symbol)) {
                    return Math.max(Math.max(0.1 * x, 0.15 * Math.max(0, K1 - x)), Math.max(0.1 * K2, 0.15 * Math.max(0, x - K2)));
                }
                else {
                    const ask = quotes[0].AskPrice;
                    if (ask > 0) {
                        x = Math.max(x, ask);
                    }
                    return Math.max(Math.max(0.1 * x, 0.2 * Math.max(0, K1 - x)), Math.max(0.1 * K2, 0.2 * Math.max(0, x - K2)));
                }
            },
        },
    },
};
export const CallCondor = {
    info: {
        Name: 'Call Condor',
        Symbol: 'CR',
        LegsAmount: 4,
        Strikes: 4,
        PermissionLevel: 4,
        SizeRatio: SizeRatio.OneToOneToOneToOne,
        SvgPath: 'call-condor',
        IconKind: 'svg',
    },
    profile: {
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Short,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Short,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Long,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 5,
            StrategyType: StrategyType.Bull,
        },
        [OrderActionDirection.Short]: {
            Strength: 4,
            StrategyType: StrategyType.Bear,
        },
        Rules: {
            Expiration: ExpirationRules.SameExpiry,
            Strike: [StrikeRules.IncreasingOrder, StrikeRules.EquidistantStrikesByTwos],
            SpreadRatio: SizeRatio.OneToOneToOneToOne,
            Direction: DirectionRules.Condor,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                //|K2 - K1|
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                return Math.abs(K2 - K1);
            },
        },
    },
};
export const PutCondor = {
    info: {
        Name: 'Put Condor',
        Symbol: 'PR',
        LegsAmount: 4,
        Strikes: 4,
        PermissionLevel: 4,
        SizeRatio: SizeRatio.OneToOneToOneToOne,
        SvgPath: 'put-condor',
        IconKind: 'svg',
    },
    profile: {
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Rules: {
            Expiration: ExpirationRules.SameExpiry,
            Strike: [StrikeRules.DecreasingOrder, StrikeRules.EquidistantStrikesByTwos],
            SpreadRatio: SizeRatio.OneToOneToOneToOne,
            Direction: DirectionRules.Condor,
        },
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Short,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Short,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 5,
            StrategyType: StrategyType.Bear,
        },
        [OrderActionDirection.Short]: {
            Strength: 4,
            StrategyType: StrategyType.Bull,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                //|K1 - K2|
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                return Math.abs(K1 - K2);
            },
        },
    },
};
export const IronButterfly = {
    info: {
        Name: 'Iron Butterfly',
        Symbol: 'IF',
        LegsAmount: 4,
        Strikes: 3,
        PermissionLevel: 4,
        SizeRatio: SizeRatio.OneToOneToOneToOne,
        SvgPath: 'iron-butterfly',
        IconKind: 'svg',
    },
    profile: {
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Rules: {
            Expiration: ExpirationRules.SameExpiry,
            Strike: [StrikeRules.IronButterfly, StrikeRules.EquidistantStrikesByTwos, StrikeRules.CallFirstPutsSecond],
            SpreadRatio: SizeRatio.OneToOneToOneToOne,
            Direction: DirectionRules.Iron,
        },
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Short,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Short,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 6,
            StrategyType: StrategyType.Volatility,
        },
        [OrderActionDirection.Short]: {
            Strength: 2,
            StrategyType: StrategyType.Volatility,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // |K1 - K2|
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                return Math.abs(K1 - K2);
            },
        },
    },
};
export const IronCondor = {
    info: {
        Name: 'Iron Condor',
        Symbol: 'IR',
        LegsAmount: 4,
        Strikes: 4,
        PermissionLevel: 4,
        SizeRatio: SizeRatio.OneToOneToOneToOne,
        SvgPath: 'iron-condor',
        IconKind: 'svg',
    },
    profile: {
        OrderClass: OrderClass.Multileg,
        Bidirectional: true,
        Rules: {
            Expiration: ExpirationRules.SameExpiry,
            Strike: [StrikeRules.IronCondor, StrikeRules.EquidistantStrikesByTwos, StrikeRules.CallFirstPutsSecond],
            SpreadRatio: SizeRatio.OneToOneToOneToOne,
            Direction: DirectionRules.Iron,
        },
        Legs: [
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Short,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Call,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Long,
            },
            {
                SpreadRatio: 1,
                AssetType: AssetType.Option,
                OptionType: OptionType.Put,
                Direction: OrderActionDirection.Short,
            },
        ],
        [OrderActionDirection.Long]: {
            Strength: 5,
            StrategyType: StrategyType.Volatility,
        },
        [OrderActionDirection.Short]: {
            Strength: 3,
            StrategyType: StrategyType.Volatility,
        },
        MarginRequirements: {
            [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                return 0;
            },
            [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
                // |K1 - K2|
                const legsArray = Object.values(legs);
                if (legsArray.length < 2) {
                    return 0;
                }
                const K1 = legsArray[0].Strike;
                const K2 = legsArray[1].Strike;
                return Math.abs(K1 - K2);
            },
        },
    },
};
// export const Collar: TradingStrategy = {
//   info: {
//     Name: 'Collar',
//     Symbol: 'CO',
//     LegsAmount: 3,
//     Strikes: 2,
//     PermissionLevel: 4,
//     SizeRatio: SizeRatio.HundredToOneToOne,
//     SvgPath: 'collar',
//     IconKind: 'svg',
//   },
//   profile: {
//     OrderClass: OrderClass.Multileg,
//     Bidirectional: true,
//     Legs: [
//       {
//         SpreadRatio: 100,
//         AssetType: AssetType.Equity,
//         Direction: OrderActionDirection.Long,
//       },
//       {
//         SpreadRatio: 1,
//         AssetType: AssetType.Option,
//         OptionType: OptionType.Call,
//         Direction: OrderActionDirection.Short,
//       },
//       {
//         SpreadRatio: 1,
//         AssetType: AssetType.Option,
//         OptionType: OptionType.Put,
//         Direction: OrderActionDirection.Long,
//       },
//     ],
//     [OrderActionDirection.Long]: {
//       Strength: 8,
//       StrategyType: StrategyType.Bull,
//     },
//     [OrderActionDirection.Short]: {
//       Strength: 8,
//       StrategyType: StrategyType.Bear,
//     },
//     Rules: {
//       Expiration: ExpirationRules.SameExpiry,
//       Strike: StrikeRules.CallHigherThanPut,
//       SpreadRatio: SizeRatio.HundredToOneToOne,
//     },
//     MarginRequirements: {
//       [OrderActionDirection.Long]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
//         // // buying shares and selling a call with strike K1 and buying a put with strike K2
//         // // margin is the same as for covered call
//         // // margin value is based on estimated price X of shares
//         // // Px(S) is the client’s specified price for the strategy
//         // if isLimitOrder then
//         // 	if MktAsk(S) > 0 then
//         // 		X = Min( MktAsk(S), Px(S) + Max(0, MktAsk(S) – K1)  // if there is available market offer in S greater than 0
//         // 	else // Px(S) is the client’s specified price for the strategy
//         // 		X = Min( Last(S), Px(S) + Max(0, Last(S) – K1)
//         // 	fi
//         // else
//         // 	if MktAsk(S) > 0 then
//         // 		X = MktAsk(S)  // Market best offer will be a good estimate for execution price
//         // 	else
//         // 		X = Last(S)  // Last price will be a good estimate for execution price X
//         // 	fi
//         // fi
//         // margin = ( X < 5 ? X : 0.5 * X ) * quantity * Multiplier;
//         const legsArray = Object.values(legs);
//         if (legsArray.length < 2) {
//           return 0;
//         }
//         const K1 = (legsArray[0] as OrderLegDTOState).Strike;
//         let x: number;
//         const ask = quotes[0].AskPrice;
//         if (isLimitOrder) {
//           if (ask > 0) {
//             x = Math.min(ask, offerPrice + Math.max(0, ask - K1));
//           } else {
//             x = Math.min(quotes[0].LastTradePrice, offerPrice + Math.max(0, quotes[0].LastTradePrice - K1));
//           }
//         } else {
//           if (ask > 0) {
//             x = ask;
//           } else {
//             x = quotes[0].LastTradePrice;
//           }
//         }
//         return x < 5 ? x : 0.5 * x;
//       },
//       [OrderActionDirection.Short]: (legs, quotes, isLimitOrder, offerPrice, isIRA) => {
//         // if MktAsk(S) > 0 then
//         // 	X = MktAsk(S)
//         // else
//         // 	X = Last(S)
//         // fi
//         // margin = MAX( 0.5 * X + MAX( 0, K2 – X ), X < 2.5 ? 2.5 : ( X < 5 ? X : (X < 50 /3.0 ? 5 : 0.3 * X ) ) )
//         const legsArray = Object.values(legs);
//         if (legsArray.length < 2) {
//           return 0;
//         }
//         let x: number = quotes[0].LastTradePrice;
//         const ask = quotes[0].AskPrice;
//         const K2 = (legsArray[1] as OrderLegDTOState).Strike;
//         if (ask > 0) {
//           x = ask;
//         }
//         return Math.max(0.5 * x + Math.max(0, K2 - x), x < 2.5 ? 2.5 : x < 5 ? x : x < 50 / 3.0 ? 5 : 0.3 * x);
//       },
//     },
//   },
// };
export const Strategies = [
    Shares,
    Call,
    Put,
    CallVertical,
    CallCalendar,
    PutVertical,
    PutCalendar,
    Straddle,
    Strangle,
    CoveredCall,
    MarriedPut,
    CallButterfly,
    PutButterfly,
    CallCondor,
    PutCondor,
    IronButterfly,
    IronCondor,
];
export const IndexStrategies = [
    Call,
    Put,
    CallVertical,
    CallCalendar,
    PutVertical,
    PutCalendar,
    Straddle,
    Strangle,
    CallButterfly,
    PutButterfly,
    CallCondor,
    PutCondor,
    IronButterfly,
    IronCondor,
];
//# sourceMappingURL=strategies.js.map